import { connect } from 'react-redux'

import SearchResultBody from './searchResultBody'
import { openModal } from '../../../../common/actions/layout'
import { getUserFavoriteCollectionID, getUserCollections, getUserCartItems } from '../../../../common/selectors/user'
import { createFavoriteCollection } from '../../../../common/actions/user/collection'
import {
  deleteBookmark,
  addBookmark
} from '../../../../common/actions/user/bookmark'

const mapStateToProps = (state) => {
  const {
    common: {
      currentSite
    },
    user: {
      token,
      preferences
    }
  } = state

  return {
    currentSite,
    collections: getUserCollections(state),
    cartItems: getUserCartItems(state),
    favoriteCollectionID: getUserFavoriteCollectionID(state),
    token,
    preferences
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteBookmark: (collectionID, itemID, id, isFavouriteCollection) => dispatch(deleteBookmark(collectionID, itemID, id, isFavouriteCollection)),
    addBookmark: (collectionId, itemId, isFavouriteCollection) => dispatch(addBookmark(collectionId, itemId, isFavouriteCollection)),
    openModal: (data) => dispatch(openModal(data)),
    createFavoriteCollection: () => dispatch(createFavoriteCollection())
  }
}

const SearchResultBodyContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResultBody)

export default SearchResultBodyContainer



// WEBPACK FOOTER //
// ./client/pages/search/result/searchResultBodyContainer.js